
const ErrorMessageComp = (props: any) => {
  return <div className="error-message">{props.name}</div>;
};



export default ErrorMessageComp;
